import React, { useState, useRef, useEffect } from "react";
import { Globe, Check, ChevronDown } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

export default function LanguageSwitcher({ dark = false }) {
  const { lang, setLang, languages } = useLang();
  const [open, setOpen] = useState(false);
  const wrap = useRef(null);
  const current = languages.find(l => l.code === lang) || languages[0];

  useEffect(() => {
    const onDoc = (e) => { if (wrap.current && !wrap.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  return (
    <div className="relative" ref={wrap}>
      <button
        onClick={() => setOpen((v) => !v)}
        className={`inline-flex items-center gap-1.5 rounded-md px-2.5 py-1.5 text-sm font-semibold border transition-colors ${dark ? "bg-white/5 border-white/15 text-[#EEE8D9] hover:bg-white/10" : "bg-white border-[#D5D0C7] text-[#1C1F22] hover:border-[#1B3626]"}`}
        aria-haspopup="listbox"
        aria-expanded={open}
        data-testid="lang-switcher"
      >
        <Globe size={14} />
        <span className="text-[16px] leading-none hidden sm:inline" aria-hidden="true">{current.flag}</span>
        <span className="uppercase tracking-wider text-[11px] font-bold">{current.code}</span>
        <ChevronDown size={12} />
      </button>
      {open && (
        <ul role="listbox" className="absolute right-0 mt-2 w-56 max-h-[70vh] overflow-y-auto rounded-md border border-[#E2DDD5] bg-white shadow-lg z-40" data-testid="lang-dropdown">
          {languages.map((l) => (
            <li key={l.code}>
              <button
                onClick={() => { setLang(l.code); setOpen(false); }}
                className={`w-full flex items-center gap-2.5 px-3 py-2.5 text-sm hover:bg-[#F7F5F0] ${l.code === lang ? "bg-[#EEF4F0] font-semibold text-[#1B3626]" : "text-[#1C1F22]"}`}
                data-testid={`lang-${l.code}`}
                dir={l.rtl ? "rtl" : "ltr"}
              >
                <span className="text-[18px] leading-none">{l.flag}</span>
                <span className="flex-1 text-left">{l.label}</span>
                {l.code === lang && <Check size={14} className="text-[#1B3626]" />}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
